import { useState, useEffect } from 'react';

import { StyledRecentWrapper, StyledRecentsTitle } from './StyledRecents';
import { PairedButtons } from '../UI/Buttons';
import { Container } from '../UI/Containers';
// import recentImg from '../../Static/images/mock/recent.png';
// import recentImg1 from '../../Static/images/mock/recent1.png';
// import recentImg2 from '../../Static/images/mock/recent2.png';
// import recentImg3 from '../../Static/images/mock/recent3.png';
// import recentImg4 from '../../Static/images/mock/recent4.png';

import { ObjectCardset } from '../Cardset';

// export const recents = [
//   {
//     id: '35565555558901311133888364',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 2,
//     created: '2021-09-01t14:48:00.000z',
//     category: 1,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//     ],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 120,
//     area: 145,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 955000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '337',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 3,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 855000,
//     pricePerMeter: '1147 €',
//     broker: 2,
//   },
//   {
//     id: '3438',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 2,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 30, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     area: 230,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 655000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '34539',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 5,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 20, type: 'wc' },
//     ],
//     square: 80,
//     area: 425,
//     year: 1998,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 355000,
//     pricePerMeter: '1147 €',
//     broker: 4,
//   },
//   {
//     id: '345640',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 3,
//     region: 1,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 40, type: 'room' },
//       { square: 10, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 140,
//     area: 525,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 455000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '35555541',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 2,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 60,
//     area: 825,
//     year: 2020,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 255000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '35555568365',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 2,
//     created: '2011-10-05t14:48:00.000z',
//     category: 1,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//     ],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 120,
//     area: 145,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 955000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '355555668937',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 3,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 855000,
//     pricePerMeter: '1147 €',
//     broker: 2,
//   },
//   {
//     id: '35555566689038',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 2,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 30, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     area: 230,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 655000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '3555556666890139',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 1,
//     state: 1,
//     region: 5,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 20, type: 'wc' },
//     ],
//     square: 80,
//     area: 425,
//     year: 1998,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 355000,
//     pricePerMeter: '1147 €',
//     broker: 4,
//   },
//   {
//     id: '355555666668901340',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 3,
//     region: 1,
//     created: '2021-09-01t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 40, type: 'room' },
//       { square: 10, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 140,
//     area: 525,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 455000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '35555566666689013141',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 3,
//     state: 3,
//     region: 4,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 60,
//     area: 825,
//     year: 2020,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 255000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '6',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 4,
//     unique: true,
//     state: 2,
//     region: 2,
//     created: '2021-09-01t14:48:00.000z',
//     category: 1,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//     ],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 120,
//     area: 145,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 955000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '3555556666666890131137',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 4,
//     unique: true,
//     state: 3,
//     region: 3,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 855000,
//     pricePerMeter: '1147 €',
//     broker: 2,
//   },
//   {
//     id: '355555666666648901311138',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 2,
//     state: 3,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 30, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     area: 230,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 655000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '35555566666664489013111339',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 4,
//     unique: true,
//     state: 2,
//     region: 5,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 20, type: 'wc' },
//     ],
//     square: 80,
//     area: 425,
//     year: 1998,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 355000,
//     pricePerMeter: '1147 €',
//     broker: 4,
//   },
//   {
//     id: '3555556666666444890131113340',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 2,
//     state: 3,
//     region: 1,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 40, type: 'room' },
//       { square: 10, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 140,
//     area: 525,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 455000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '355555666666644448901311133341',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 2,
//     state: 3,
//     region: 4,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 60,
//     area: 825,
//     year: 2020,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 255000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '355555666666644444890131113333367',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 4,
//     unique: true,
//     state: 3,
//     region: 2,
//     created: '2021-09-01t14:48:00.000z',
//     category: 1,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//       recentImg,
//       recentImg1,
//       recentImg2,
//       recentImg3,
//       recentImg4,
//     ],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 120,
//     area: 145,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 955000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '35565890131113333337',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 4,
//     unique: true,
//     state: 1,
//     region: 3,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 855000,
//     pricePerMeter: '1147 €',
//     broker: 2,
//   },
//   {
//     id: '3556558901311133333338',
//     country: '612f24e9cc411c2a70a3a45d',
//     type: 2,
//     state: 3,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 30, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 100,
//     area: 230,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 655000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
//   {
//     id: '35565558901311133839',
//     type: 1,
//     state: 1,
//     region: 5,
//     created: '2011-10-05t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 30, type: 'room' },
//       { square: 20, type: 'kitchen' },
//       { square: 20, type: 'wc' },
//     ],
//     square: 80,
//     area: 425,
//     year: 1998,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 355000,
//     pricePerMeter: '1147 €',
//     broker: 4,
//   },
//   {
//     id: '355655558901311133840',
//     type: 2,
//     state: 3,
//     region: 1,
//     created: '2011-10-05t14:48:00.000z',
//     category: 2,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 40, type: 'room' },
//       { square: 10, type: 'room' },
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 140,
//     area: 525,
//     year: 2021,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 455000,
//     pricePerMeter: '1147 €',
//     broker: 1,
//   },
//   {
//     id: '35565555589013111338841',
//     type: 2,
//     state: 3,
//     region: 4,
//     created: '2021-09-01t14:48:00.000z',
//     category: 5,
//     title: 'Paskutinis !!! Pradedama rezervacija naujai statomo vieno aukšto',
//     img: [recentImg, recentImg1, recentImg2, recentImg3, recentImg4],
//     rooms: [
//       { square: 20, type: 'room' },
//       { square: 10, type: 'kitchen' },
//       { square: 10, type: 'wc' },
//     ],
//     square: 60,
//     area: 825,
//     year: 2020,
//     address: 'Klemiškė, Klaipėdos r. sav.',
//     price: 255000,
//     pricePerMeter: '1147 €',
//     broker: 3,
//   },
// ];

export const recents = [];

export const RecentObjects = ({ objects }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [data, setData] = useState(objects);

  const handleClick = index => {
    setActiveIndex(index);
  };

  useEffect(() => {
    if (activeIndex === 0) {
      setData(
        objects.filter(
          ({ created }) =>
            Date.now() - Date.parse(created) < 1000 * 60 * 60 * 24 * 30,
        ),
      );
    }
    if (activeIndex === 1) {
      setData(objects.filter(el => el.unique));
    }
  }, [activeIndex, objects]);

  return (
    <StyledRecentWrapper as="section">
      <StyledRecentsTitle>
        <h2>MŪSŲ SIŪLOMI OBJEKTAI</h2>
        <h3>
          MŪSŲ PASIŪLYMAI BEI SKELBIMAI PASIRODO VISŲ SVARBIAUSIŲ NEKILNOJAMOJO
          TURTO PORTALŲ PAGRINDINIUOSE PUSLAPIUOSE.
        </h3>
        <PairedButtons
          text={['NAUJAUSI OBJEKTAI', 'YPATINGI OBJEKTAI']}
          active={activeIndex}
          disabled={false}
          fn={handleClick}
        />
      </StyledRecentsTitle>
      <Container>
        <ObjectCardset data={data} />
      </Container>
    </StyledRecentWrapper>
  );
};
